const en = {
  appTitle: 'Spinning Wheel',
  loading: 'Loading...',

  // PlayerForm
  claimPrizeTitle: 'Claim Your Prize!',
  formSubtitle: 'Enter your info to claim your prize',
  emailLabel: 'Email (optional)',
  emailPlaceholder: 'you@example.com',
  emailError: 'Please enter a valid email address.',
  phoneLabel: 'Phone Number',
  phonePlaceholder: '+1 234 567 8900',
  phoneError: 'Please enter a valid phone number.',
  submitInfo: 'Claim Prize!',

  // SpinningWheel
  spin: 'SPIN!',
  spinning: 'Spinning...',
  congratulations: 'Congratulations!',
  youWon: 'You won:',
  resultFollowupMessage: 'Ms. Tam will contact you right away for consultation. Thank you!!',
  contactName: 'Ms.Tam_English Class',
  contactPhone: '0373.731.398',
};

export default en;
